if (!customElements.get('announcement-marquee')) {
  customElements.define(
    'announcement-marquee',
    class AnnouncementMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.marquee__track');
        this.list = this.querySelector('.marquee__list:not([aria-hidden="true"])');

        if (!this.track || !this.list) return;

        this.lastWidth = 0;
        this.lastUnit = 0;
        this.build();

        // Rebuild quando a viewport muda ou a lista muda de largura (ex.: webfont carregou).
        this.resizeObserver = new ResizeObserver(() => {
          if (
            this.clientWidth === this.lastWidth &&
            Math.abs(this.list.getBoundingClientRect().width - this.lastUnit) < 1
          ) {
            return;
          }
          this.build();
        });
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.list);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      // Clona a lista ate as copias cobrirem a viewport + uma lista de sobra, entao a faixa
      // nunca mostra vazio, mesmo com 1 aviso curto. O deslocamento da animacao e a
      // largura exata de uma lista (loop sem salto).
      build() {
        const unit = this.list.getBoundingClientRect().width;
        if (!unit) return;

        this.lastWidth = this.clientWidth;
        this.lastUnit = unit;
        this.track.querySelectorAll('.marquee__list[aria-hidden="true"]').forEach((el) => el.remove());

        const copies = Math.max(1, Math.ceil(this.lastWidth / unit));
        for (let i = 0; i < copies; i++) {
          const clone = this.list.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('aria-live');
          clone.querySelectorAll('[data-block-id], [id]').forEach((el) => el.removeAttribute('id'));
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        }

        const speed = parseFloat(this.dataset.speed) || 60;
        this.track.style.setProperty('--marquee-end', `-${unit}px`);
        this.track.style.setProperty('--marquee-duration', `${unit / speed}s`);
      }
    }
  );
}
